import { Box, BoxProps, IconButton } from '@material-ui/core';
import { TwitterIcon } from 'modules/common/components/Icons/TwitterIcon';
import React, { useMemo } from 'react';
import { uid } from 'react-uid';
// import { MediumIcon } from 'modules/common/components/Icons/MediumIcon';
import { useSocialStyles } from './SocialStyles';
import { GithubIcon } from '../../../common/components/Icons/GithubIcon';

// import { DiscordIcon } from '../../../common/components/Icons/DiscordIcon';

export const Social = (props: BoxProps) => {
  const classes = useSocialStyles();

  const links = useMemo(
    () => [
      {
        title: 'Github',
        icon: GithubIcon,
        href: 'https://github.com/insevm',
      },
      {
        title: 'Twitter',
        icon: TwitterIcon,
        href: 'https://twitter.com/ins_evm',
      },
    ],
    [],
  );

  return (
    <Box {...props} component="nav">
      <ul className={classes.list}>
        {links.map(({ title, href, icon: Icon }) => {
          return (
            <li className={classes.listItem} key={uid(title)}>
              <IconButton
                component="a"
                href={href}
                role="link"
                rel="noopener noreferrer"
                target="_blank"
                className={classes.link}
                {...(props as any)}
              >
                <Icon className={classes.icon} />
              </IconButton>
            </li>
          );
        })}
      </ul>
    </Box>
  );
};
